import React, { useRef } from "react";
import styles from "./index.module.css";
import { AudioButton } from "../AudioButton";
import { SoundWaves } from "../SoundWaves";

import { useSelector } from "react-redux";
import { RootState } from "@/store";

import { useTranslation } from "react-i18next";

interface Props {
    setAvatarVideoTag: (arg: HTMLVideoElement) => void;
    isRecording?: boolean;
    setIsRecording: (state: boolean) => void;
    setQuestion: (state: string) => void;
    sendQuestion: (state: string) => void;
    isFullScreen: boolean;
}

export const Avatar: React.FC<Props> = ({ setAvatarVideoTag, isRecording, setIsRecording, setQuestion, sendQuestion, isFullScreen }) => {
    const waitVideo = useRef<HTMLVideoElement>(null);
    const isAvatarOn = useSelector((state: RootState) => state.values.isAvatarOn);
    const avatarSound = useSelector((state: RootState) => state.values.isSoundOn);
    const talkState = useSelector((state: RootState) => state.values.talkState);

    const { t } = useTranslation();

    const commonMediaProps = {
        playsInline: true,
        muted: !isAvatarOn || !avatarSound,
        autoPlay: true
    };

    return (
        <div className={`${styles.container} ${isFullScreen ? styles.fullScreen : ""}`}>
            <div className={`${styles.AvatarFrame} ${styles.video}`}>
                <video
                    {...commonMediaProps}
                    className={styles.AvatarVideo }
                    hidden={isAvatarOn && talkState === "talk" ? true : false}
                    loop={true}
                    ref={waitVideo}
                >
                    <source src={"/new_dsara_smile.mp4"} type="video/mp4" />
                </video>
                <video
                    {...commonMediaProps}
                    hidden={isAvatarOn && talkState === "talk" ? false : true}
                    className={styles.AvatarVideo}
                    ref={thisTalkVideo => {
                        if (thisTalkVideo) {
                            setAvatarVideoTag(thisTalkVideo);
                        }
                    }}
                />
                <div className={styles.feedback}>
                    <span className={styles.label}>
                        {t("settings.video.label")} {isRecording ? t("settings.video.active") : t("settings.video.disabled")}
                    </span>
                    <div className={styles.animation}>{isRecording && <SoundWaves />}</div>
                </div>
            </div>
            <div className={styles.audio}>
                <div className={styles.text}>
                    <h5 className={styles.title}>{t("settings.video.title")}</h5>
                    <p className={styles.text}>{t("settings.video.description")}</p>
                </div>
                <AudioButton isRecording={isRecording} setIsRecording={setIsRecording} setQuestion={setQuestion} sendQuestion={sendQuestion} />
            </div>
        </div>
    );
};
